module.exports = __webpack_public_path__ + "static/houses-apartments-23e3edc395057645e61f5ace9d36125a.jpg";